import { canvasService } from './canvasService';
export class ImageProcess {
    constructor(base64, options) {
        this.base64 = base64;
        this.options = options;
    }
    /**
     * Used to stitch together functional operators into a chain.
     * @method pipe
     * @returns Processed base64 string
     *
     * ### Example
     * ```ts
     * import { imageProcessor, pipe, resize } from 'ts-image-processor';
     *
     * imageProcessor.src(myBase64String)
     *   .pipe(
     *     resize({maxWidth: 800, maxHeight: 800}),
     *     sharpen(),
     *   )
     *   .then(processedBase64 => {
     *     // Do whatever
     *   });
     * ```
     */
    pipe(...operations) {
        if (!operations) {
            return Promise.resolve(this.base64);
        }
        return new Promise(resolve => {
            canvasService.drawBase64(this.base64).then(() => {
                operations.reduce((promiseChain, currentOperation) => {
                    return promiseChain.then(() => currentOperation(this.base64));
                }, Promise.resolve())
                    .then(() => {
                    resolve(canvasService.canvas.toDataURL(this.options.type, this.options.jpgQuality));
                });
            });
        });
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW1hZ2UtcHJvY2Vzcy5tb2RlbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvaW1hZ2UtcHJvY2Vzcy5tb2RlbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsYUFBYSxFQUFFLE1BQU0saUJBQWlCLENBQUM7QUFHaEQsTUFBTSxPQUFPLFlBQVk7SUFDdkIsWUFBb0IsTUFBYyxFQUFVLE9BQW1CO1FBQTNDLFdBQU0sR0FBTixNQUFNLENBQVE7UUFBVSxZQUFPLEdBQVAsT0FBTyxDQUFZO0lBQy9ELENBQUM7SUFFRDs7Ozs7Ozs7Ozs7Ozs7Ozs7O09Ba0JHO0lBQ0gsSUFBSSxDQUFDLEdBQUcsVUFBOEI7UUFDcEMsSUFBSSxDQUFDLFVBQVUsRUFBRTtZQUNmLE9BQU8sT0FBTyxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLENBQUM7U0FDckM7UUFFRCxPQUFPLElBQUksT0FBTyxDQUFDLE9BQU8sQ0FBQyxFQUFFO1lBQzNCLGFBQWEsQ0FBQyxVQUFVLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDLElBQUksQ0FBQyxHQUFHLEVBQUU7Z0JBQzlDLFVBQVUsQ0FBQyxNQUFNLENBQUMsQ0FBQyxZQUFZLEVBQUUsZ0JBQWdCLEVBQUUsRUFBRTtvQkFDbkQsT0FBTyxZQUFZLENBQUMsSUFBSSxDQUFDLEdBQUcsRUFBRSxDQUM1QixnQkFBZ0IsQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQztnQkFDbkMsQ0FBQyxFQUFFLE9BQU8sQ0FBQyxPQUFPLEVBQUUsQ0FBQztxQkFDbEIsSUFBSSxDQUFDLEdBQUcsRUFBRTtvQkFDVCxPQUFPLENBQUMsYUFBYSxDQUFDLE1BQU0sQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxJQUFJLEVBQUUsSUFBSSxDQUFDLE9BQU8sQ0FBQyxVQUFVLENBQUMsQ0FBQyxDQUFDO2dCQUN0RixDQUFDLENBQUMsQ0FBQztZQUNQLENBQUMsQ0FBQyxDQUFDO1FBQ0wsQ0FBQyxDQUFDLENBQUM7SUFDTCxDQUFDO0NBQ0YifQ==